import { ENDPOINTS } from "@/constants/endpoints";
import { route } from "@/utils/route";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { api, getToken } from "../api";
import { getOrgIdFromToken } from "../utils";

export interface NangoConnectionSessionParams {
  allowed_integrations: string[];
}

export interface NangoConnectionSessionResponse {
  data: {
    token: string;
    expires_at: string;
  };
}

export async function postNangoConnectionSession(
  params: NangoConnectionSessionParams,
) {
  const token = await getToken();
  const orgId = getOrgIdFromToken(token);
  return api.post<
    NangoConnectionSessionResponse,
    AxiosResponse<NangoConnectionSessionResponse>,
    NangoConnectionSessionParams
  >(
    route(ENDPOINTS.ORG.NANGO.CONNECT_SESSION, {
      organization_id: orgId,
    }),
    params,
  );
}

export function usePostNangoConnectionSession(
  options?: UseMutationOptions<
    AxiosResponse<NangoConnectionSessionResponse>,
    unknown,
    NangoConnectionSessionParams
  >,
) {
  return useMutation({
    mutationKey: ["postNangoConnectionSession"],
    mutationFn: postNangoConnectionSession,
    ...options,
  });
}
